module.exports = __webpack_public_path__ + "img/javascript.2d368183.svg";